export default __webpack_public_path__ + "static/media/oxxopay.6d7d0e3c.svg";